<template>
  <b-notification type="is-danger" :active.sync="alert">
    {{ error }}
  </b-notification>
</template>

<script>
export default {
  name: 'errorMessage',
  data () {
    return {
      alert: false
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.alert = true
      } else {
        this.alert = false
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  },
  computed: {
    error () {
      return this.$store.getters.isErroneous
    }
  }
}
</script>

<style>

</style>
